// Barreira de erro (levantamento de 02/10, item A5). Ver `registro-de-erros.js`.
//
// Três níveis, porque o que a pessoa precisa depende de quanto quebrou:
//   - "app":    nada se salvou; tela cheia, com "Recarregar a página";
//   - "tela":   a área principal quebrou, mas o menu e o cabeçalho seguem de pé; oferece "Voltar ao início";
//   - "painel": uma gaveta ou modal quebrou; oferece "Fechar", e o resto do app continua usável.
//
// `chave` é o que identifica "onde a pessoa está" (a rota). Quando ela muda, o erro é limpo: sair da tela que
// quebrou tem de poder funcionar sem recarregar. Se a chave não muda, o erro fica (um defeito que continua
// não pode ser escondido).

import React from 'react';
import { registrarErro, textoParaSuporte } from './registro-de-erros.js';

export class ErroNaTela extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, registro: null, copiado: false };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    const registro = registrarErro(this.props.nivel || 'tela', erro, {
      componente: (info?.componentStack || '').split('\n').slice(0, 4).join('\n'),
    });
    this.setState({ registro });
  }

  componentDidUpdate(anterior) {
    if (this.state.erro && anterior.chave !== this.props.chave) {
      this.setState({ erro: null, registro: null, copiado: false });
    }
  }

  recarregar = () => {
    (this.props.aoRecarregar || (() => window.location.reload()))();
  };

  copiar = async () => {
    const texto = textoParaSuporte(this.state.registro) || String(this.state.erro?.message || '');
    try {
      await navigator.clipboard.writeText(texto);
      this.setState({ copiado: true });
    } catch (e) {
      // Sem permissão de área de transferência: o texto continua no console, com o prefixo [BeamCRM].
      console.error('[BeamCRM] não foi possível copiar os detalhes:', e?.message);
    }
  };

  fechar = () => {
    this.props.onFechar?.();
    this.setState({ erro: null, registro: null, copiado: false });
  };

  render() {
    if (!this.state.erro) return this.props.children;
    const nivel = this.props.nivel || 'tela';
    const copiar = (
      <button type="button" className="btn" onClick={this.copiar}>
        {this.state.copiado ? 'Detalhes copiados' : 'Copiar detalhes'}
      </button>
    );

    if (nivel === 'painel') {
      return (
        <div className="erro-painel" role="alert">
          <strong>Não foi possível abrir este painel.</strong>
          <span>O restante do CRM continua funcionando.</span>
          <div className="erro-acoes">
            <button type="button" className="btn primary" onClick={this.fechar}>Fechar</button>
            {copiar}
          </div>
        </div>
      );
    }

    return (
      <div className={`erro-na-tela erro-${nivel}`} role="alert">
        <h2>Algo deu errado {nivel === 'app' ? 'no BeamCRM' : 'nesta tela'}</h2>
        <p>
          O que já estava salvo continua salvo; o que você estava digitando pode não ter sido salvo.
          Tente voltar ou recarregar. Se o problema se repetir, copie os detalhes e envie ao responsável pelo CRM.
        </p>
        <div className="erro-acoes">
          <button type="button" className="btn primary" onClick={this.recarregar}>Recarregar a página</button>
          {nivel === 'tela' && this.props.aoVoltar && (
            <button type="button" className="btn" onClick={this.props.aoVoltar}>Voltar ao início</button>
          )}
          {copiar}
        </div>
      </div>
    );
  }
}
